// staticContentSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StaticContent, StaticContentState } from "./types.tsx";

const initialState: StaticContentState = {
  content: null,
  loading: false,
  error: null,
};

const staticContentSlice = createSlice({
  name: "staticContent",
  initialState,
  reducers: {
    fetchContentStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchContentSuccess: (state, action: PayloadAction<StaticContent>) => {
      state.content = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchContentFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchContentStart, fetchContentSuccess, fetchContentFailure } =
  staticContentSlice.actions;

export default staticContentSlice.reducer;
